<div class="form-group">
    <label>{{title}} {{control | controlRequiredText}}

        <i class="pj-ico pj-ico-ayuda-info text-primary" [ngClass]="{'d-none':!popoverContent}" data-toggle="popover"
            data-placement="top" data-html="true" data-trigger="hover" [attr.data-content]="popoverContent"
            tabindex="0">
        </i>
    </label>

    <input-text [id]="id" [title]="title" [maxlength]="maxlength" [placeholder]="placeholder"
        [showIconSuccess]="showIconSuccess" [control]="control"></input-text>

        <small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}
            <a class="btn-link" *ngIf="messageFooterAction" (click)="onClickActionFooter($event)" role="button"
                [title]="messageFooterAction">{{messageFooterAction}}</a>
        </small>

    <div-validation-message [control]="control" [messageRequired]="messageRequired" [messagePattern]="messagePattern"
        [messageCustomFn]="messageCustomFn">
    </div-validation-message>

</div>